import { listTimeTitleFunc } from '@op/components/ChartCommon/formatter';
import TranslateSelect from '@op/components/FilterBoxCommon/filters/languages';
import { LanguageType } from '@op/types/common';
import { transLanguage, transMode } from '@op/utils';
import React from 'react';
import DatabrainAI from '@op/assets/svg/databrain_ai.svg';
import SvgIcon from '@home/components/SvgIcon';
import { sentimentTypeMap } from '@op/components/ReviewsModal/constants';
import DboExpandCollapseText from '@op/components/ExpandCollapse';

interface IVoiceReportingTextAnalysisColumns {
  formatMessage: any;
  languages: Array<LanguageType>;
  setLanguages?: (value: Array<LanguageType>) => void;
  renderKey?: string;
  filter: any;
  firstLanguage: LanguageType;
  transIntent: (intent: string) => string;
}
export const voiceReportingTextAnalysisColumnsFunc = (props: IVoiceReportingTextAnalysisColumns) => {
  const {
    formatMessage,
    languages,
    setLanguages,
    filter,
    firstLanguage,
    transIntent
  } = props;

  return {
    origin: {
      key: 'text',
      header: (
        <div className="dbo-table-header-reviews">
          {formatMessage({ id: 'Report Text' })}
          <TranslateSelect
            onChange={(key, value) => {
              setLanguages?.(value);
            }}
            key={'languages'}
            defaultValue={['origin']}
            defaultParams={{ value: languages }}
            defaultValueText={formatMessage({ id: 'Language' })}
          />
        </div>
      ),
      width: 520,
      fixed: 'left',
      render: (cvm: any) => (
        <div className='dbo-table-text-content'>
          <SvgIcon
            type={sentimentTypeMap[cvm.sentiment_rating]}
            className="dbo-title-flex-icon"
          />
          <DboExpandCollapseText
            noHtml
            className="reviewbox-content"
            text={cvm.text}
            rowNum={2}
          />
        </div>
      ),
    },
    en: {
      key: 'text_en',
      header: (
        <div className="dbo-table-header-reviews">
          {formatMessage({ id: 'Report Text in English' })}
          {firstLanguage === 'en' && (
            <TranslateSelect
              onChange={(key, value) => {
                setLanguages?.(value);
              }}
              key={'languages'}
              defaultValue={['origin']}
              defaultParams={{ value: languages }}
            />
          )}
        </div>
      ),
      align: 'left',
      fixed: firstLanguage === 'en' ? 'left' : '',
      width: 520,
      render: (cvm: any) => (
        <div className='dbo-table-text-content'>
          <SvgIcon
            type={sentimentTypeMap[cvm.sentiment_rating]}
            className="dbo-title-flex-icon"
          />
          <DboExpandCollapseText
            noHtml
            className="reviewbox-content"
            text={cvm.text_en}
            rowNum={2}
          />
        </div>
      ),
    },
    zh: {
      key: 'text_zh',
      header: (
        <div className="dbo-table-header-reviews">
          {formatMessage({ id: 'Report Text in Chinese' })}
          {firstLanguage === 'zh' && (
            <TranslateSelect
              onChange={(key, value) => {
                setLanguages?.(value);
              }}
              key={'languages'}
              defaultValue={['origin']}
              defaultParams={{ value: languages }}
            />
          )}
        </div>
      ),
      align: 'left',
      fixed: firstLanguage === 'zh' ? 'left' : '',
      width: 520,
      render: (cvm: any) => (
        <div className='dbo-table-text-content'>
          <SvgIcon
            type={sentimentTypeMap[cvm.sentiment_rating]}
            className="dbo-title-flex-icon"
          />
          <DboExpandCollapseText
            noHtml
            className="reviewbox-content"
            text={cvm.text_zh}
            rowNum={2}
          />
        </div>
      ),
    },
    create_time: {
      key: 'create_time',
      header: formatMessage({ id: 'Create Time' }),
      align: 'left',
      width: 180,
      render: (cvm: any) => listTimeTitleFunc(cvm.create_time, filter.date_type),
    },
    report_time: {
      key: 'report_time',
      header: formatMessage({ id: 'Report Time' }),
      align: 'left',
      width: 180,
      render: (cvm: any) => listTimeTitleFunc(cvm.report_time, filter.date_type),
    },
    language: {
      key: 'language',
      header: formatMessage({ id: 'Language' }),
      align: 'left',
      width: 180,
      render: (cvm: any) => transLanguage(cvm?.language),
    },
    intent: {
      key: 'intent',
      header: formatMessage({ id: 'Intent' }),
      align: 'left',
      width: 300,
      render: (cvm: any) => (
        <DboExpandCollapseText
          noHtml
          className="reviewbox-content"
          text={transIntent(cvm.intent)}
          rowNum={2}
        />
      ),
    },
    reason: {
      key: 'reason',
      header: (
        <div className="dbo-table-header-reason">
          <img
            src={DatabrainAI}
            className={`dbo-table-header-icon`}
          />
          {formatMessage({ id: 'Reason' })}
        </div>
      ),
      align: 'left',
      width: 300,
      render: (cvm: any) => (
        <DboExpandCollapseText
          noHtml
          className="reviewbox-content"
          text={cvm.reason}
          rowNum={2}
        />
      ),
    },
    battle_id: {
      key: 'battle_id',
      header: formatMessage({ id: 'Battleid' }),
      align: 'left',
      width: 150,
      render: (cvm: any) => (
        <div className='dbo-table-report-id'>{cvm.battle_id}</div>
      )
    },
    report_open_id: {
      key: 'report_open_id',
      header: formatMessage({ id: 'Reportopenid' }),
      align: 'left',
      width: 150,
      render: (cvm: any) => (
        <div className='dbo-table-report-id'>{cvm.report_open_id}</div>
      )
    },
    mode: {
      key: 'mode',
      header: formatMessage({ id: 'Mode' }),
      align: 'left',
      width: 150,
      render: (cvm: any) => transMode(cvm?.mode),
    },
    id: {
      key: 'id',
      header: formatMessage({ id: 'ID' }),
      align: 'left',
      width: 150,
      render: (cvm: any) => (
        <div className='dbo-table-report-id'>{cvm.id}</div>
      )
    },
  }
}